
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/integratedTerminal",
      function () {
        return require("private-next-pages/hardware/integratedTerminal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/integratedTerminal"])
      });
    }
  